import type { BankAsset } from "~/types/assets.types";
import { BankAccountTypes } from "~/utils/accountEnums";

export const bankInterest = (userProduct: BankAsset) => {
  const amount = userProduct?.amount || 0;
  const interest = userProduct?.interest || 0;
  const accountType = userProduct?.accountType?.value || "";

  return (accountType === BankAccountTypes.BALANCE ||
    accountType === BankAccountTypes.FOREIGN_CURRENCY) &&
    amount < 0
    ? interest * -1
    : accountType === BankAccountTypes.SAVING
    ? interest
    : undefined;
};
